export type CalendarEvent = {
  date: string;       // YYYY-MM-DD
  endDate?: string;    // YYYY-MM-DD
  startTime?: string;  // HH:mm (24h)
  endTime?: string;    // HH:mm (24h)
  timezone?: string;   // IANA e.g. "America/Los_Angeles"
  title: string;
  type: string;
  location: string;
  zoomLink?: string;
  meetingId?: string;
  passcode?: string;
};

/** Add one day to YYYY-MM-DD string */
const nextDay = (isoDate: string) => {
  const d = new Date(isoDate + "T12:00:00"); // noon to avoid DST edge cases
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
};

export const generateGoogleCalendarLink = (event: CalendarEvent) => {
  const startDateStr = event.date.replace(/-/g, "");
  const endDateRaw = event.endDate || event.date;

  let startCal: string;
  let endCal: string;

  if (event.startTime && event.endTime) {
    startCal = `${startDateStr}T${event.startTime.replace(":", "")}00`;
    endCal = `${endDateRaw.replace(/-/g, "")}T${event.endTime.replace(":", "")}00`;
  } else {
    startCal = startDateStr;
    endCal = nextDay(endDateRaw).replace(/-/g, "");
  }

  let description = `${event.type} - ${event.title}`;
  if (event.zoomLink) {
    description += `\n\nZoom Meeting: ${event.zoomLink}\nMeeting ID: ${event.meetingId}\nPasscode: ${event.passcode}`;
  }

  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: event.title,
    dates: `${startCal}/${endCal}`,
    details: description,
    location: event.location,
    ...(event.timezone && { ctz: event.timezone }),
  });

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const generateOutlookCalendarLink = (event: CalendarEvent) => {
  const endDateRaw = event.endDate || event.date;
  const isAllDay = !event.startTime || !event.endTime;

  const startDt = isAllDay
    ? event.date
    : `${event.date}T${event.startTime}:00`;
  const endDt = isAllDay
    ? nextDay(endDateRaw)
    : `${endDateRaw}T${event.endTime}:00`;

  let description = `${event.type} - ${event.title}`;
  if (event.zoomLink) {
    description += `\n\nZoom Meeting: ${event.zoomLink}\nMeeting ID: ${event.meetingId}\nPasscode: ${event.passcode}`;
  }

  const params = new URLSearchParams({
    path: "/calendar/action/compose",
    rru: "addevent",
    subject: event.title,
    startdt: startDt,
    enddt: endDt,
    body: description,
    location: event.location,
    ...(isAllDay && { allday: "true" }),
  });

  return `https://outlook.office.com/calendar/0/deeplink/compose?${params.toString()}`;
};
